import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "href", "className", "label", "type", "isDark", "darkMode", "leftIcon", "rightIcon", "children"],
  _excluded2 = ["htmlProps"],
  _excluded3 = ["htmlProps"],
  _excluded4 = ["htmlProps"],
  _excluded5 = ["htmlProps"];
import { forwardRef } from 'react';
import parseClassnames from "../../helpers/parseClassnames";
import ButtonWithLabelChildren from "../ButtonWithLabelChildren";
import { DARK_LINKS, LIGHT_LINKS } from "./classnames";
import { jsx as _jsx } from "react/jsx-runtime";
var TextLink = function TextLink(_ref, ref) {
  var _ButtonWithLabelChild;
  var as = _ref.as,
    href = _ref.href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    label = _ref.label,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'level1' : _ref$type,
    isDark = _ref.isDark,
    darkMode = _ref.darkMode,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    children = _ref.children,
    textLinkProps = _objectWithoutProperties(_ref, _excluded);
  var wrapperClassName = parseClassnames(className, isDark || darkMode ? DARK_LINKS[type] : LIGHT_LINKS[type]);
  var renderChildren = function renderChildren() {
    return _ButtonWithLabelChild || (_ButtonWithLabelChild = /*#__PURE__*/_jsx(ButtonWithLabelChildren, {
      label: label,
      leftIcon: leftIcon,
      rightIcon: rightIcon,
      children: children
    }));
  };
  if (as === 'a' || href) {
    var _ref2 = textLinkProps,
      _htmlProps = _ref2.htmlProps,
      aProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      href: href,
      className: wrapperClassName
    }, _htmlProps), aProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'label') {
    var _ref3 = textLinkProps,
      _htmlProps2 = _ref3.htmlProps,
      labelProps = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps2), labelProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'span') {
    var _ref4 = textLinkProps,
      _htmlProps3 = _ref4.htmlProps,
      spanProps = _objectWithoutProperties(_ref4, _excluded4);
    return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps3), spanProps), {}, {
      children: renderChildren()
    }));
  }
  var _ref5 = textLinkProps,
    htmlProps = _ref5.htmlProps,
    buttonProps = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    type: "button",
    className: wrapperClassName
  }, htmlProps), buttonProps), {}, {
    children: renderChildren()
  }));
};
export default /*#__PURE__*/forwardRef(TextLink);